import React, { useEffect, useState } from "react";
import { FaBars, FaReceipt } from "react-icons/fa";
import { TfiMenuAlt } from "react-icons/tfi";
import {
  MdOutlineInventory,
  MdShoppingCart,
  MdTableRestaurant,
} from "react-icons/md";
import { IoIosSettings } from "react-icons/io";
// import backOffice from "../../Asset/back office.png";
// import support from "../../Asset/support.png";
import { NavLink, useNavigate } from "react-router-dom";
import { BsCartCheckFill } from "react-icons/bs";
import { BiSolidReport } from "react-icons/bi";
import { GiCash } from "react-icons/gi";
// import authServices from "../../redux/features/auth/AuthServies";
// import { selectUser } from "../../redux/features/auth/AuthSlice";
// import { useSelector } from "react-redux";
import { AdminCashier, AdminOnly } from "../Protect/HiddenLink";
import { getUser, selectUser } from "../../redux/features/auth/AuthSlice";
import { useDispatch, useSelector } from "react-redux";
import { PiReceiptFill } from "react-icons/pi";
import { AdminCashierCounter } from "../../Protect/HiddenLink";

const sidebarSections = [
  { name: "Orders", icon: <MdShoppingCart />, path: "/tableNo" },
  { name: "Receipts", icon: <FaReceipt />, path: "/receipts" },
  {
    name: "Kitchen Receipts",
    icon: <PiReceiptFill />,
    path: "/kitchen-receipts",
  },
  {
    name: "Completing Order",
    icon: <BsCartCheckFill />,
    path: "/completingOrder",
  },
  { name: "Tables", icon: <MdTableRestaurant />, path: "/tables" },
  { name: "Reports", icon: <BiSolidReport />, path: "/reports" },
  { name: "Cash In/Out", icon: <GiCash />, path: "/cashInOut/expenses" },
  { name: "Purchase", icon: <MdOutlineInventory />, path: "/purchases" },
  { name: "Items", icon: <TfiMenuAlt />, path: "/items" },

  { name: "Settings", icon: <IoIosSettings />, path: "/settings" },
];

// const sidebarGuide = [
//   { name: "Back office", image: backOffice },
//   { name: "Support", image: support, version: "v 2.30.1" },
// ];

const SidebarNav = () => {
  const [isOpen, setIsOpen] = useState(false);
  // const [userRole, setUserRole] = useState(null);
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const toggleSidebar = () => setIsOpen(!isOpen);

  const navigation = (path) => {
    navigate(path);
    setIsOpen(false);
  };

  useEffect(() => {
    const handler = (event) => {
      if (!event.target.closest(".sidebar") && isOpen) setIsOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [isOpen]);

  // useEffect(() => {
  // const fetchUserRole = async () => {
  //   try {
  //     const isLoggedIn = await authServices.getLoginStatus();
  //     if (isLoggedIn) {
  //       const response = await authServices.getUser();
  //       setUserRole(response.data.role);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching user role:", error);
  //   }
  // };

  // fetchUserRole();
  //   if (user) {
  //     setUserRole(user?.role);
  //   }
  // }, [user]);

  useEffect(() => {
    dispatch(getUser());
  }, [dispatch]);

  return (
    <div className="relative">
      {/* Sidebar Toggle Button */}
      <FaBars
        onClick={toggleSidebar}
        className="text-white md:text-xl text-[.9rem] cursor-pointer"
      />

      {/* Sidebar and Overlay */}
      <div
        className={`${
          isOpen ? "fixed inset-0 z-50 bg-black bg-opacity-70" : ""
        }`}
        onClick={() => setIsOpen(false)}
      >
        <div
          className={`fixed z-10 top-0 left-0 h-full lg:w-[30%] md:w-[39%] w-[75%] overflow-y-auto scrollbar-hide bg-white text-[#555555] transform ${
            isOpen ? "translate-x-0" : "-translate-x-full hidden"
          } transition-transform duration-300 ease-in-out sidebar`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex flex-col min-h-screen justify-between gap-6">
            {/* Top Section */}
            <div>
              <div className="flex items-center bg-[#555555] text-white lg:py-3 py-2 lg:px-6 px-3 gap-4">
                <img
                  src={user?.profile}
                  className="md:w-20 w-16 rounded-full"
                  alt="User"
                />
                <div>
                  <h1 className="lg:text-[1.3rem] text-[.9rem] font-inter-700">
                    Al-Noor Restaurant
                  </h1>
                  <p className="lg:text-[.9rem] text-[.7rem] font-inter-400">
                    POS 1
                  </p>
                  <p className="lg:text-[.9rem] text-[.7rem] font-inter-400 capitalize">
                    {user?.name}
                  </p>
                </div>
              </div>

              {/* <div>
                {sidebarSections.map((section) => {
                  const isAdminOnly = ["Items", "Tables"].includes(
                    section.name
                  );
                  const isAdminOrCashier = [
                    "Purchase",
                    "Receipts",
                    "Reports",
                    "Cash In/Out",
                  ].includes(section.name);

                  if (isAdminOnly && userRole !== "admin") return null;
                  if (
                    isAdminOrCashier &&
                    !(userRole === "admin" || userRole === "cashier")
                  )
                    return null;

                  return (
                    <NavLink
                      key={section.path}
                      to={section.path}
                      className={({ isActive }) =>
                        `px-6 lg:px-8 lg:py-3 py-2 border-b border-[#DEDEDE] cursor-pointer 
              lg:text-[.9rem] text-[.7rem] font-inter-600 flex items-center 
              hover:text-white hover:bg-[#0D868C] ${
                isActive ? "text-white bg-[#0D868C]" : "bg-white text-[#A9A9A9]"
              }`
                      }
                      onClick={() => navigation(section.path)}
                    >
                      <div className="flex items-center">
                        <span className="mr-4 text-[1.2rem]">
                          {section.icon}
                        </span>
                        <span>{section.name}</span>
                      </div>
                    </NavLink>
                  );
                })}
              </div> */}

              {sidebarSections.map((section) => {
                const isRestrictedToAdmin = ["Items", "Tables"].includes(
                  section.name,
                );

                const isRestrictedToAdminCashier = [
                 
                  "Reports",
                  "Purchase",
                  "Cash In/Out",
                ].includes(section.name);

                 const isRestrictedToAdminCashierCounter = [
                  "Receipts",
                  "Kitchen Receipts",
                ].includes(section.name);

                const navLink = (
                  <NavLink
                    to={section.path}
                    className={({ isActive }) =>
                      `px-6 lg:px-8 lg:py-3 py-2 border-b border-[#DEDEDE] cursor-pointer 
        lg:text-[.9rem] text-[.7rem] font-inter-600 flex items-center 
        hover:text-white hover:bg-[#0D868C] ${
          isActive ? "text-white bg-[#0D868C]" : "bg-white text-[#A9A9A9]"
        }`
                    }
                    onClick={() => navigation(section.path)}
                  >
                    <div className="flex items-center">
                      <span className="mr-4 text-[1.2rem]">{section.icon}</span>
                      <span>{section.name}</span>
                    </div>
                  </NavLink>
                );

                if (isRestrictedToAdmin) {
                  return <AdminOnly key={section.path}>{navLink}</AdminOnly>;
                }

                if (isRestrictedToAdminCashier) {
                  return (
                    <AdminCashier key={section.path}>{navLink}</AdminCashier>
                  );
                }
                if (isRestrictedToAdminCashierCounter) {
                  return (
                    <AdminCashierCounter key={section.path}>{navLink}</AdminCashierCounter>
                  );
                }

                return <div key={section.path}>{navLink}</div>;
              })}
            </div>

            {/* Lower Section */}
            {/* <div>
              {sidebarGuide.map((guide, i) => (
                <div
                  key={i}
                  className="px-6 lg:px-8 lg:py-3 py-2 cursor-pointer lg:text-[1rem] text-[.8rem] font-inter-600 flex items-center bg-white text-[#A9A9A9]"
                >
                  <img src={guide.image} alt={guide.name} className="mr-4" />
                  <div className="flex justify-between w-full items-center">
                    <span className="text-[#0D868C]">{guide.name}</span>
                    <span className="lg:text-[12px] text-[10px] font-inter-600">
                      {guide.version}
                    </span>
                  </div>
                </div>
              ))}
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SidebarNav;
